import { MantineTheme } from "@mantine/core";
import { createStyles } from "@mantine/emotion";

export const useStyles = createStyles((_theme: MantineTheme) => ({
  buttonClass: {
    width: "365px",
    height: "45px",
    padding: "13px 87px 13px 87px",
    border: "none",
    gap: "10px",
    fontSize: "16px",

    letterSpacing: "0em",
    textAlign: "center",
  },
}));
